import React from 'react';
import { render } from 'react-dom';
import { App } from './app';

// retrieve data from server to hydrate on the client
const props = window.__LISTINGS_PROPS__ || ({} as any);

const root = document.getElementById('listings-root');

render(<App {...props} />, root);
